import script from "./DashboardPrayerRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPrayerRequests.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPrayerRequests.vue?vue&type=style&index=0&id=727328b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-727328b6"]])

export default __exports__